var map = {
	"./coin_APE.png": 2930,
	"./coin_BITCOIN.png": 9548,
	"./coin_BNB.png": 1292,
	"./coin_BTC.png": 4654,
	"./coin_CANTO.png": 3875,
	"./coin_CLB.png": 9175,
	"./coin_DOGE.png": 2948,
	"./coin_ETH.png": 151,
	"./coin_JEWEL.png": 3016,
	"./coin_LTC.png": 4664,
	"./coin_MATIC.png": 2254,
	"./coin_NOTE.png": 4841,
	"./coin_PEPE.png": 8654,
	"./coin_PIXL.png": 5914,
	"./coin_SHIB.png": 1230,
	"./coin_SOL.png": 611,
	"./coin_TRX.png": 9773,
	"./coin_USDC.png": 7014,
	"./coin_USDT.png": 2278,
	"./coin_WETH.png": 5332,
	"./coin_WIT.png": 7334,
	"./coin_XMR.png": 1600,
	"./coin_XRP.png": 5989
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1479;